import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { IProfile, IResponse } from '@interfaces/index';
import { AppService } from '@ui-components/services';
import { switchMap } from 'rxjs';
import { ProfileService } from '../../services/profile.service';
import { IQuestion } from 'projects/ui-components/src/interfaces/IProfile';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-experience',
  templateUrl: './experience.component.html',
  styleUrl: './experience.component.scss'
})
export class ExperienceComponent {

  form: FormGroup;
  loading = false;
  profile: IProfile | null = null;
  experience: IQuestion[] = [];
  person_id: number | undefined;

  constructor(
    protected _app_service: AppService,
    protected _profile_service: ProfileService,
    protected _fb: FormBuilder,
    protected _route: ActivatedRoute,
    public router: Router
  ) {
    this.form = this._fb.group({
      answers: this._fb.array([])
    });
  }


  ngOnInit() {

    this._app_service.getProfile().pipe(
      switchMap(
        (response: IResponse<IProfile>) => {
          this.profile = response.data
          const person_id_param = this._route.snapshot.paramMap.get('person_id');
          this.person_id = person_id_param ? +person_id_param : undefined;
          return this._profile_service.getExperience(this.person_id);
        }
      )
    ).subscribe(
      (response: IResponse<IQuestion[]>) => {
        this.experience = response.data;
        this.experience.forEach(question => {
          this.answers.push(this._fb.group({
            question_id: [question.question_id],
            answer_id: [question.answer?.answer_id || '']
          }))
        })
      }
    )
  }
  
  get answers() {
    return this.form.get('answers') as FormArray;
  }

  update() {
    // The response carries no questions, so `experience` is left as loaded.
    this._profile_service.updateExperience(this.form.get('answers')?.value, this.person_id).subscribe()
  }

}
